import { NoopTask } from './noopTask.types'

export const createNoopTask = ({
  name,
  taskReferenceName,
  inputParameters
}: Omit<NoopTask, 'type'>): NoopTask => {
  return {
    type: 'NOOP',
    name,
    taskReferenceName,
    inputParameters
  }
}
